import { Link } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';

const AdminAnalyticsPage = () => {
  const { user } = useAuth();

  // Проверяем права: superuser или наличие роли 'admin'
  const hasAccess = user?.superuser || user?.roles?.some(role => role.name === 'admin');

  return (
    <div className="main-content">
      <div className="page-header mb-4">
        <h1>Управление аналитикой</h1>
      </div>

      {hasAccess ? (
        <div className="d-flex gap-3">
          <Link to="/edit-themes" className="btn btn-primary">
            Редактировать темы аналитики
          </Link>
        </div>
      ) : (
        <p>У вас нет прав для управления аналитикой.</p>
      )}
    </div>
  );
};

export default AdminAnalyticsPage;